import {
    GET_COMPANY_CONFIG,
    GET_WHITE_STAR_VALUES,
} from './types/getters';

const getters = {
    [GET_COMPANY_CONFIG](state) {
        return state.companyConfig;
    },
    [GET_WHITE_STAR_VALUES](state) {
        return state.whiteStarValues;
    },
};

export default getters;
